import * as DOMUtils from "history/DOMUtils";
import { type AbortableRequestStatus, RequestStatusEnum } from "../../../common-deprecated/types/CommonTypes";
import type { AbortableFetchFnReturnType } from "../../../common-deprecated/utils/backendFetch";

export const isRequestPossible = (status: AbortableRequestStatus, refresh: boolean = false): boolean => {
    return !!(
        status === RequestStatusEnum.Idle ||
        (DOMUtils.canUseDOM && status === RequestStatusEnum.Aborted) ||
        status === RequestStatusEnum.Fetching ||
        (refresh && status === RequestStatusEnum.Complete)
    );
};

export const getRequestFailureStatus = <T>(result: AbortableFetchFnReturnType<T>): AbortableRequestStatus => {
    return result.aborted ? RequestStatusEnum.Aborted : RequestStatusEnum.Error;
};
